<section>
  <div class="form-register">
    <form [formGroup]="formOrderDetail">
      <div class="row p-1">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [value]="codeNameArticle" [disabled]="true" [labelText]="'Artículo'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="workshopStock" [labelText]="'Taller'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="shopStock" [labelText]="'Almacén'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="reservedStock"
            [labelText]="'Reservado'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="availableStock"
            [labelText]="'Disponible'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-datepicker formControlName="compromiseDate" [required]="true"
            [labelText]="'Compromiso'"></app-custom-datepicker>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantityInitial" [required]="true" [labelText]="'Cant.Ini.'"
            (onChangeNumber)="changeQuantityInitial($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantityFinal" [labelText]="'Cant.Fin.'"
            (onChangeNumber)="changeQuantityFinal($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantityReserved" [labelText]="'Cant.Reserva'"
            (onChangeNumber)="changeQuantityReserved($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex mt-2 justify-content-end">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disableButtonSave"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>